import { graphql } from "relay-runtime"
import { betterDocExchangesQuery$variables } from "@/modules/admin/better-doc/services/__generated__/betterDocExchangesQuery.graphql"

export const betterDocExchangesQuery = graphql`
  query betterDocExchangesQuery($filter: de_BetterDocExchangeFilterInput, $first: Int) {
    ...betterDocExchangesQueryListFragment @arguments(filter: $filter, first: $first)
  }
`

export const betterDocExchangesQueryListFragment = graphql`
  fragment betterDocExchangesQueryListFragment on Query
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    filter: { type: "de_BetterDocExchangeFilterInput" }
  )
  @refetchable(queryName: "BetterDocExchangesPaginationQuery") {
    exchanges: de_betterDocExchanges(first: $first, after: $after, filter: $filter)
      @connection(key: "BetterDocExchangesFragment_exchanges", filters: ["filter"]) {
      edges {
        node {
          exchangeId
          operation
          actor
          httpMethod
          requestUri
          isTestCase
          hasUnexpectedResponse
          responseStatusCode
          durationMilliseconds
          startedAt
          outcome
          failureKind
        }
      }
    }
  }
`

export type BetterDocExchangeFilter = NonNullable<betterDocExchangesQuery$variables["filter"]>
